import * as React from 'react';

import { IRoadSuggest } from '../../../store/roads';
import { RoadIcon } from '../../icons';

import { ListGroup, ListItem } from './ListGroup';
import { getSuggestLinkText } from './getSuggestLinkText';

import * as styles from './index.css';

interface IRoadsSuggestionsProps {
  textValue: string;
  suggests: IRoadSuggest[];
  handleItemSelect(suggest: IRoadSuggest): void;
}

export const RoadsSuggestions: React.FC<IRoadsSuggestionsProps> = props => {
  const { suggests, handleItemSelect, textValue } = props;

  return (
    <ListGroup title="Шоссе" icon={<RoadIcon />}>
      {suggests.map(suggest => (
        <ListItem key={`suggestion-${suggest.id}`} onClick={() => handleItemSelect(suggest)}>
          <span>{getSuggestLinkText(suggest.name, textValue)}</span>
          {suggest.directionName && <div className={styles['list-item_description']}>{suggest.directionName}</div>}
        </ListItem>
      ))}
    </ListGroup>
  );
};
